var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import { Translate } from "../../I18N";
import { wrapDispatch } from "../../Multireducer";
import { Icon } from "../../UI";
import React, { useMemo } from 'react';
import { bindActionCreators } from 'redux';


import {
  uploadDocument as uploadDocumentAction,
  createDocument as createDocumentAction } from "../../Uploads/actions/uploadsActions";


import { unselectAllDocuments as unselectAllDocumentsAction } from "../actions/libraryActions";
import { connect } from 'react-redux';

const extractTitle = (file) => {
  const title = file.name.
  replace(/\.[^/.]+$/, '').
  replace(/_/g, ' ').
  replace(/-/g, ' ').
  replace(/ {2}/g, ' ');

  return title.charAt(0).toUpperCase() + title.slice(1);
};









const onChangePDFs =
({ createDocument, uploadDocument, unselectAllDocuments }) =>
(e) => {
  const { files } = e.target;
  const count = (files === null || files === void 0 ? void 0 : files.length) || 0;

  // eslint-disable-next-line no-plusplus
  for (let index = 0; index < count; index++) {
    const file = files[index];
    const doc = { title: extractTitle(file) };
    createDocument(doc).
    then((newDoc) => {
      uploadDocument(newDoc.sharedId, file);
    }).
    catch(() => {});
  }

  unselectAllDocuments();
};

const PDFUploadButtonComponent = ({
  createDocument,
  uploadDocument,
  unselectAllDocuments
}) => {
  const onChangeHandler = useMemo(
    () =>
    onChangePDFs({
      createDocument,
      uploadDocument,
      unselectAllDocuments
    }),
    [createDocument, uploadDocument, unselectAllDocuments]
  );

  return /*#__PURE__*/(
    _jsx("label", { htmlFor: "pdf-upload-button", className: "btn btn-default" }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "cloud-upload-alt" }), /*#__PURE__*/
    _jsx("span", { className: "btn-label" }, void 0, /*#__PURE__*/
    _jsx(Translate, {}, void 0, "Upload PDF(s) to create")
    ), /*#__PURE__*/
    _jsx("input", {
      type: "file",
      id: "pdf-upload-button",
      style: { display: 'none' },
      accept: "application/pdf",
      multiple: true,
      onChange: onChangeHandler }
    )
    ));

};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      uploadDocument: uploadDocumentAction,
      unselectAllDocuments: unselectAllDocumentsAction,
      createDocument: createDocumentAction
    },
    wrapDispatch(dispatch, 'library')
  );
}

export const PDFUploadButton = connect(
  null,
  mapDispatchToProps
)(PDFUploadButtonComponent);